var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CompanyEnabledFeatureKeyType, RoleType } from 'common/types/server-api-dtos';
import { CommonServiceApiTags } from '../api-tags';
import { useCustomizationStore } from '../customizations-service/service-store/service-store';
import { customizationsServiceIsEnabledFeatureKeySelector } from '../customizations-service/service-store/selectors';
import { useChatUnreadStore } from './service-store/service-store';
import { chatUnreadServiceUnreadMessagesCountSelector } from './service-store/selectors';
import { userService } from 'common/utils/user-service';
import { fetchChatUnreadMessagesCountApi } from './api';
import { ONE_MINUTE } from 'common/constants/common-time';
export var useChatUnreadData = function () {
    var setPageContent = useChatUnreadStore(function (state) { return state.setPageContent; });
    var setError = useChatUnreadStore(function (state) { return state.setError; });
    var unreadMessagesCount = useChatUnreadStore(chatUnreadServiceUnreadMessagesCountSelector);
    var isChatEnabled = useCustomizationStore(customizationsServiceIsEnabledFeatureKeySelector(CompanyEnabledFeatureKeyType.EnableChat));
    var isAuth = userService.isLoggedIn();
    var _a = useQuery({
        queryKey: [CommonServiceApiTags.ChatUnread],
        enabled: isAuth && userService.hasRole(RoleType.Basic) && isChatEnabled,
        refetchInterval: unreadMessagesCount > 0 ? ONE_MINUTE : false,
        queryFn: fetchChatUnreadMessagesCountApi,
    }), data = _a.data, dataUpdatedAt = _a.dataUpdatedAt, error = _a.error;
    useEffect(function () {
        if (error) {
            setError(error);
            return;
        }
        if (data) {
            setPageContent(__assign(__assign({}, data), { unreadMessagesCount: Number(data.unreadMessagesCount) }));
        }
    }, [data, dataUpdatedAt, error, setError, setPageContent]);
};
